import React from 'react';

// Squelette de carte produit : réserve exactement la même hauteur
// que CSProductCard afin d'éviter tout décalage de mise en page (CLS)
// pendant le chargement des produits sur la page d'accueil.
export default function CSProductCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden flex flex-col animate-pulse">
      <div className="aspect-square bg-gray-100" />
      <div className="p-3 flex flex-col gap-2">
        <div className="h-2.5 w-1/3 bg-gray-200 rounded" />
        <div className="h-3 w-4/5 bg-gray-200 rounded" />
        <div className="h-2 w-2/5 bg-gray-100 rounded" />
        <div className="h-2.5 w-1/4 bg-gray-100 rounded mt-1" />
        <div className="flex items-end justify-between mt-3">
          <div className="h-4 w-1/3 bg-gray-200 rounded" />
          <div className="h-7 w-16 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
}